import React from 'react';
import Menu from '../components/Navbar';


const Construction = () => {
    return (
        <>
            <Menu />
        </>
    )
}

export default Construction